export default __webpack_public_path__ + "static/media/svg-1.041483a4.svg";